import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import loaderimage from "../../images/giphy.gif";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";

const Testimonials = () => {
    const [testimonialList, setTestimonialList] = useState<any[]>([]);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [actionType, setActionType] = useState("");
    const [selectedTestimonialId, setSelectedTestimonialId] = useState<number | null>(null);
  
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [showFailureModal, setShowFailureModal] = useState(false);
    const [failureMessage, setFailureMessage] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    const fetchTestimonials = async () => {
      try {
        setLoader(true);
        setError(null);
        const url = process.env.REACT_APP_API_URL + "testimonials/showtestimonials";
        const response = await axios.get(url);
        const activeTestimonials = response.data.filter((testimonial: { is_active: number }) => testimonial.is_active === 1);
        setTestimonialList(activeTestimonials); 
      } catch (error: any) {
        setError(error.message || "Failed to fetch testimonials.");
        console.error("Error fetching testimonials:", error);
      } finally {
        setLoader(false);
      }
    };
  
    useEffect(() => {
      fetchTestimonials();
    }, []);
  
    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
      };

    const handleAction = async () => {
      if (!selectedTestimonialId) return;
  
      try {
        if (actionType === "Delete") {
          const url = `${process.env.REACT_APP_API_URL}testimonials/delete/${selectedTestimonialId}`;
          const token = localStorage.getItem("jwttoken") || "";
          await axios.put(url,{},
          {headers: {"x-access-token": token}
            });
          setSuccessMessage("Testimonial deleted successfully.");
        }
        fetchTestimonials();
        setShowSuccessModal(true);
      } catch (error: any) {
        console.error(`Error performing ${actionType} action:`, error);
        setFailureMessage(`Failed to delete testimonial. ${error.message || ''}`);
        setShowFailureModal(true); 
      } finally {
        setShowModal(false);
        setSelectedTestimonialId(null);
        
      }
    };
  
    const triggerActionModal = (action: string, testimonialId: number) => {
      setSelectedTestimonialId(testimonialId);
      setActionType(action);
      if (action === "Delete") {
        setModalMessage("Are you sure you want to delete this testimonial?");
      }
      setShowModal(true);
    };
  
    const filteredTestimonials = React.useMemo(() => {
      if (!searchTerm) return testimonialList;
      return testimonialList.filter((testimonial) =>
          testimonial.author_name?.toLowerCase().includes(searchTerm) ||
          testimonial.author_designation?.toLowerCase().includes(searchTerm) ||
          testimonial.testimonial_text?.toLowerCase().includes(searchTerm)
      );
  }, [searchTerm, testimonialList]);


    return (
      <div className="">
        <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-black fw-bold">Testimonials Management</h2>
          <div className="d-flex gap-2 align-items-center" style={{width:"510px"}}>
            <span className="fw-bold text-secondary text-nowrap">{filteredTestimonials.length} results</span>
            <input
              type="text"
              className="form-control"
              placeholder="Search by Auther Name or Designation"
              value={searchTerm}
              onChange={handleSearch}
            />
          <Link to="/testimonialadd" className="btn bg-info">+ Add Testimonial</Link>
          </div>
        </div>
        <div className="card shadow-sm border-0 rounded">
          <div className="card-header bg-info border-bottom py-3">
            <h5 className="mb-0 text-white">Testimonial List</h5>
          </div>
          <div className="card-body p-0">
              <div className="table-responsive" style={{ maxHeight: "500px", overflowY: "auto" }}>
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light sticky-top" style={{ position: "sticky", top: 0, zIndex: 1020 }}>
                    <tr>
                      <th>#</th>
                      <th>Author</th>
                      <th>Image</th>
                      <th>Designation</th>
                      <th>Testimonial</th>
                      <th>Rating</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                  {loader ? (
                  <tr>
                    <td colSpan={7} className="text-center py-4">
                      <img src={loaderimage} alt="Loading..." height="40" />
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan={7} className="text-center text-danger fw-bold py-3">
                      <div className="alert alert-danger text-center m-3" role="alert">
                        Oops! Something went wrong. Please try again later.
                      </div>
                    </td>
                  </tr>
                ) : filteredTestimonials.length > 0 ? (
                  filteredTestimonials.map((item, index) => (
                    <tr key={item.testimonial_Id} className="border-bottom">
                      <td>{index+1}</td>
                      <td>{item.author_name}</td>
                      <td>
                        <img 
                          src={`${process.env.REACT_APP_API_URL}${item.author_image}`} 
                          alt="Author" 
                          style={{ width: "50px", height: "50px", borderRadius: "50%" }} 
                        />
                      </td>
                      <td>{item.author_designation}</td>
                      <td>{item.testimonial_text}</td>
                      <td>{item.rating}
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <Link to={`/testimonialedit/${item.testimonial_Id}`} className="btn btn-sm btn-outline-warning">Edit</Link>
                          <button className="btn btn-sm btn-outline-secondary" onClick={() => triggerActionModal("Delete", item.testimonial_Id)}>
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                ))) : (
                  <tr>
                    <td colSpan={7} className="text-center text-muted fw-bold">
                      <div className="alert alert-secondary text-center m-3" role="alert">
                        No Testimonials Available
                      </div>
                    </td>
                  </tr>
                )}
                  
                    
                  </tbody>
                </table>
              </div>
          </div>
          
        </div>
        
        
        <ConfirmationModal show={showModal} onHide={() => setShowModal(false)} modalMessage={modalMessage} confirmation={handleAction} operationType={actionType} />
        <NewconfirmationModal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} modalMessage={successMessage} operationType="OK" timeoutDuration={3000} />
        <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage}  operationType="OK" timeoutDuration={5000}/>
      </div>
    );
  
}

export default Testimonials